"use client";

import * as React from "react";
import { MonitorSmartphone, Lightbulb, TrendingUp, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Planejamento",
  description: "Definição estratégica de canais e narrativas para posicionar sua marca com autoridade no ambiente digital desde o primeiro dia.",
  icon: Lightbulb,
  link: "/ServicesPage"
}, {
  title: "Execução",
  description: "Produção técnica de alta performance, transformando conceitos em ativos digitais de impacto com foco em qualidade estética e funcional.",
  icon: MonitorSmartphone,
  link: "/ServicesPage"
}, {
  title: "Otimização",
  description: "Análise contínua de métricas e ajustes estratégicos para garantir que sua presença digital evolua e gere resultados consistentes.",
  icon: TrendingUp,
  link: "/ServicesPage"
}];
export default function Leistungen() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="234688" id="serviços" className="relative overflow-hidden bg-background text-foreground py-24 sm:py-32">
      {}
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center bg-background">
        <div className="h-[40rem] w-[40rem] rounded-full bg-primary/5 blur-3xl"></div>
      </div>

      <div ref={ref} className={`container relative mx-auto px-4 md:px-6 transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="mb-16 max-w-2xl">
          <h2 className="font-default text-3xl font-bold tracking-tight text-foreground sm:text-4xl">
            Nossos Serviços
          </h2>
          <p className="mt-4 text-lg text-muted-foreground font-default">
            Soluções completas para estruturar sua presença digital com foco em 
            estratégia, design de alta conversão e crescimento sustentável.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <Card key={i} data-index={i} className="group relative flex flex-col overflow-hidden border border-border bg-white shadow-none transition-all duration-500 hover:-translate-y-1 hover:border-accent hover:shadow-md">
                <CardHeader className="pb-4">
                  <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10 text-primary transition-colors group-hover:bg-primary group-hover:text-primary-foreground">
                    <Icon className="size-6" strokeWidth={2} />
                  </div>
                  <CardTitle className="font-default text-2xl font-semibold text-foreground">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="flex-1 pb-6">
                  <CardDescription className="text-base leading-relaxed text-muted-foreground font-default">
                    {service.description}
                  </CardDescription>
                </CardContent>
                <CardFooter className="pt-0">
                  <Link to={service.link} className="group/link relative inline-flex items-center gap-2 pb-1 text-sm font-medium text-primary">
                    Saiba mais
                    <ArrowRight className="size-4 transition-transform duration-300 group-hover/link:translate-x-1" />
                    <span className="absolute bottom-0 left-0 h-[1px] w-0 bg-primary transition-all duration-300 ease-out group-hover/link:w-full"></span>
                  </Link>
                </CardFooter>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}